import { useEffect, useRef } from "react";
import Api from "api";

interface MissionTimeTrackerProps {
	children: React.ReactNode;
	missionNumber: number;
}

function MissionTimeTracker({ children, missionNumber }: MissionTimeTrackerProps)
{
	const isActiveRef = useRef(true);
	const lastActivityRef = useRef(Date.now());
	const intervalRef = useRef<NodeJS.Timeout | null>(null);

	function updateActivity()
	{
		lastActivityRef.current = Date.now();
	}

	async function checkActivity()
	{
		const now = Date.now();
		const diff = now - lastActivityRef.current;
		const isCurrentlyActive = diff < 20_000 && document.visibilityState === "visible";

		// даже если активность не изменилась, отправим пульс при активном состоянии
		if (isCurrentlyActive)
		{
			await Api.users.setMissionTime("pulse", missionNumber, new Date().toISOString(), true);
		}
		else if (isActiveRef.current !== isCurrentlyActive)
		{
			isActiveRef.current = isCurrentlyActive;
			await Api.users.setMissionTime("pulse", missionNumber, new Date().toISOString(), false);
		}
	}

	function handleUnload()
	{
		try
		{
			navigator.sendBeacon(
				"/api/users/setMissionTime",
				JSON.stringify({
					action: "end",
					missNumber: missionNumber,
					timestamp: new Date().toISOString(),
					active: false
				})
			);
		}
		catch (e)
		{
			// fallback
			Api.users.setMissionTime("end", missionNumber, new Date().toISOString(), false).catch(console.error);
		}
	}

	useEffect(() =>
	{
		updateActivity();

		Api.users.setMissionTime("start", missionNumber, new Date().toISOString(), true).catch(console.error);

		window.addEventListener("mousemove", updateActivity);
		window.addEventListener("keydown", updateActivity);
		window.addEventListener("beforeunload", handleUnload);
		document.addEventListener("visibilitychange", checkActivity);

		intervalRef.current = setInterval(checkActivity, 10_000);

		return () =>
		{
			handleUnload();

			if (intervalRef.current) clearInterval(intervalRef.current);

			window.removeEventListener("mousemove", updateActivity);
			window.removeEventListener("keydown", updateActivity);
			window.removeEventListener("beforeunload", handleUnload);
			document.removeEventListener("visibilitychange", checkActivity);
		};
	}, [ missionNumber ]);

	return <>{children}</>;
}

export default MissionTimeTracker;
